import { registerSW } from 'virtual:pwa-register';

/**
 * Enregistrement du service worker.
 *
 * Sans lui, pas de Web Push : c'est le service worker qui recoit l'evenement
 * `push` et affiche la notification. Le cache hors ligne n'est qu'un bonus.
 *
 * La mise a jour n'est jamais appliquee d'office : recharger la page pendant
 * qu'on coche une liste ferait perdre le fil. On attend la prochaine ouverture
 * a froid, ou un accord explicite.
 */
export function enregistrerSW(): void {
  if (!('serviceWorker' in navigator)) return;

  const majDisponible = registerSW({
    immediate: true,
    onNeedRefresh() {
      // Au prochain demarrage complet de l'app, la nouvelle version prendra la
      // main d'elle-meme. Si l'app est ouverte depuis longtemps, on propose.
      if (document.visibilityState === 'visible' && window.confirm('Nouvelle version. Recharger ?')) {
        void majDisponible(true);
      }
    },
    onRegisterError(e) {
      console.warn('Service worker non enregistre', e);
    },
  });
}
